import { useState, useEffect } from 'react'

/**
 * Hook per gestire lo stato di ordinamento con persistenza in localStorage.
 * 
 * @param {string} pageKey - Chiave univoca per la pagina (es: 'prodotti', 'ordini')
 * @param {string} defaultOrdering - Ordinamento di default (es: 'nome', '-created_at')
 * @returns {[string, Function]} - [ordering, setOrdering]
 * 
 * @example
 * const [ordering, setOrdering] = useSortingState('prodotti', 'nome')
 * // ordering = 'nome' o '-nome' o altro valore salvato
 */
export function useSortingState(pageKey, defaultOrdering = 'id') {
  const storageKey = `sorting_${pageKey}`
  
  // Inizializza da localStorage o usa default
  const [ordering, setOrderingState] = useState(() => {
    try {
      const saved = localStorage.getItem(storageKey)
      return saved || defaultOrdering
    } catch {
      return defaultOrdering
    }
  })
  
  // Wrapper per setOrdering che salva anche in localStorage
  const setOrdering = (newOrdering) => {
    setOrderingState(newOrdering)
    try {
      localStorage.setItem(storageKey, newOrdering)
    } catch {
      // Ignora errori localStorage (es: quota exceeded, private mode)
    }
  }
  
  return [ordering, setOrdering]
}

export default useSortingState
